export default "__VITE_ASSET__DumS_3mm__"